import { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import Configuration from "./Configuration";
import { FormattedMessage } from "react-intl";

const ConfigurationPage = () => {
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(1);

  const { controllerDetails, scopeStatus, purposes, languageStatus } =
    useSelector((state) => state.controller);
  const controllerDetailsLoaded = useMemo(
    () => ["succeeded", "failed"]?.includes(scopeStatus),
    [scopeStatus],
  );
  const purposesLoaded = useMemo(
    () => ["succeeded", "failed"]?.includes(languageStatus),
    [languageStatus],
  );

  useEffect(() => {
    if (controllerDetailsLoaded && purposesLoaded) {
      setLoading(false);
    }
  }, [controllerDetailsLoaded, purposesLoaded]);

  return (
    <div className="country-config">
      <h2 className="fs-3 fw-normal py-2">
        <FormattedMessage
          id="Controller Configurations"
          defaultMessage="Controller Configurations"
        />
      </h2>

      <Configuration
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        configdetails={{ data: controllerDetails }}
        configtabledetails={{ data: purposes ?? [] }}
        loading={loading}
      />
    </div>
  );
};

export default ConfigurationPage;
